<template>
  <div class="l-learn-exam-container" v-if="element">
    <!-- 考试规则 -->
    <LLearnRule v-if="showModel == 1" @start="onStart" />
    <!-- 答题 -->
    <LLearnQuestion v-else-if="showModel == 2" :time="time" :currentIndex="currentIndex" @select="onSelect"
      @toggle="onGoCard" @submit="onSubmit" @next-item="onNext" @pre-item="onPre" @jump="onJump" />
    <!-- 答题卡 -->
    <LLearnCard v-else-if="showModel == 3" :answerList="answerList" :time="time" :currentIndex="currentIndex"
      @jump="onJump" @submit="onSubmit" />
  </div>
</template>

<script>
import LLearnCard from './components/l-learn-card'
import LLearnQuestion from './components/l-learn-question'
import LLearnRule from './components/l-learn-rule'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters, mapActions } = createNamespacedHelpers('course')

export default {
  name: 'l-learn-exam',
  components: { LLearnCard, LLearnQuestion, LLearnRule },
  data() {
    return {
      showModel: 0, // 1考试规则  2题目  3答题卡
      currentIndex: 0, // 跳转题号
      countdown: 0, // 倒计时（秒）
      timer: 0, // 定时器
      time: '', // 倒计时（时分秒）
      isChange: false, // 是否是修改题
      answerList: [], // 本地缓存数据
      userId: '',
      currentInfo: null,
    }
  },
  computed: {
    ...mapGetters(['element']),
  },
  watch: {
    'element.ELEMENT_TYPE'(to) {
      if (to) {
        // 总时长
        const totalTime = this.element.attrs.examDuration * 60 * 1000
        if (this.element.time && this.element.time < totalTime) {
          // 已启动
          this.answerList = this.element.records || []
          this.currentIndex = this.answerList.length
            ? this.answerList.length - 1
            : 0
          this.currentInfo = this.answerList[this.currentIndex]
          this._start()
        } else {
          // 未启动
          this.showModel = 1
        }
      }
    }
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    ...mapActions(['STUDY_TIME', 'STUDY_RESULT']),
    onSelect(data) {
      this.STUDY_RESULT({
        elementId: this.element.id,
        postData: data.answer,
      }).then((res) => {
        if (res && res.id) {
          this.answerList = this.element.records
          this.onNext()
        }
      })
    },
    // 启动答题
    onStart() {
      this._start()
    },
    onNext() {
      if (this.currentIndex < this.element.datas.length - 1) {
        this.currentIndex += 1
      }
    },
    onPre() {
      if(this.currentIndex<=0){
        return
      }
      this.currentIndex -= 1
    },
    // 答题卡
    onGoCard() {
      this.showModel = 3
    },
    // 答题页
    onJump(index) {
      this.currentIndex =
        index == null || isNaN(index) ? this.currentIndex : index
      this.showModel = 2
    },
    onSubmit(status = false) {
      this._submit(status)
    },
    _submit(status = false) {
      this.$emit('submit', {
        result: this.answerList,
        autoCommit: status,
      })
    },
    _start() {
      this.STUDY_TIME({
        elementId: this.element.id,
      })
        .then((data) => {
          // 时间已到 自动提交
          if (data.time <= 0) {
            this.$lPrompt({
              message: '本次闯关已到时间，将会自动提交闯关纪录',
              successFn: () => {
                this._submit(true)
              },
            })
          } else {
            this.showModel = 2
            this._timer()
          }
        })
        .catch((err) => {
          console.log('启动失败：', err)
        })
    },

    // 获取倒计时时间
    async _timer() {
      this.countdown = this.element.time / 1000
      this.timer = setInterval(() => {
        this._countDown()
      }, 1000)
    },
    // 倒计时
    _countDown() {
      let result = parseInt(this.countdown)
      let arr = []
      if (result >= 0) {
        arr[0] = parseInt(result / 60 / 60)
        arr[1] = parseInt((result / 60) % 60)
        arr[2] = parseInt(result % 60)
        arr[0] > 0 ? arr : arr.shift()
        this.time = arr.map((item) => (item > 9 ? item : `0${item}`)).join(':')
        this.countdown = --result
      } else {
        clearInterval(this.timer)
        this.timer = null
        this.$lPrompt({
          message: '本次闯关已到时间，将会自动提交闯关纪录',
          successFn: () => {
            this.onSubmit(true)
          },
        })

      }
    },
  },
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>